import AbandonedForm from './abandoned-form.svg';
import ActiveTimeOnSite from './active-time-on-site.svg';
import Activity from './activity.svg';
import APIError from './api-error.svg';
import AjaxError from './ajax-error.svg';
import Browser from './browser.svg';
import ChangedFormElement from './changed-form-element.svg';
import City from './city.svg';
import Country from './country.svg';
import CSSSelector from './css-selector.svg';
import CumulativeLayoutShift from './cumulative-layout-shift.svg';
import CustomEvent from './custom-event.svg';
import DeadClick from './dead-click.svg';
import DefinedEvent from './defined-event.svg';
import Device from './device.svg';
import DisplayHeight from './display-height.svg';
import DisplayWidth from './display-width.svg';
import DurationRendered from './duration-rendered.svg';
import DurationVisible from './duration-visible.svg';
import Email from './email.svg';
import ErrorClick from './error-click.svg';
import FirstSeen from './first-seen.svg';
import FirstInputDelay from './first-input-delay.svg';
import Help from './help.svg';
import IP from './ip.svg';
import LargestContentfulPaint from './largest-contentful-paint.svg';
import LastSeen from './last-seen.svg';
import MobileSourceFile from './mobile-source-file.svg';
import Name from './name.svg';
import OS from './operating-system.svg';
import PageLoad from './page-load.svg';
import PageRefresh from './page-refresh.svg';
import Rage from './rage.svg';
import Referrer from './referrer.svg';
import ScrollDepth from './scroll-depth.svg';
import SessionCount from './session-count.svg';
import SignedUp from './signed-up.svg';
import State from './state.svg';
import String from './string.svg';
import SuspiciousActivity from './suspicious-activity.svg';
import ThrashedCursor from './thrashed-cursor.svg';
import UncaughtException from './uncaught-exception.svg';
import UserAgent from './user-agent.svg';
import UserId from './user-id.svg';
import Visited from './visited.svg';
import WatchedElement from './watched-element.svg';
import WebSourceFile from './web-source-file.svg';
import PinchZoom from './pinch-zoom.svg';
import Highlight from './text-highlight.svg';
import Copy from './copy.svg';
import Paste from './paste.svg';

export default {
  'omnisearch/abandoned-form': AbandonedForm,
  'omnisearch/active-time-on-site': ActiveTimeOnSite,
  'omnisearch/activity': Activity,
  'omnisearch/api-error': APIError,
  'omnisearch/ajax-error': AjaxError,
  'omnisearch/browser': Browser,
  'omnisearch/changed-form-element': ChangedFormElement,
  'omnisearch/city': City,
  'omnisearch/country': Country,
  'omnisearch/css-selector': CSSSelector,
  'omnisearch/cumulative-layout-shift': CumulativeLayoutShift,
  'omnisearch/custom-event': CustomEvent,
  'omnisearch/dead-click': DeadClick,
  'omnisearch/defined-event': DefinedEvent,
  'omnisearch/device': Device,
  'omnisearch/display-height': DisplayHeight,
  'omnisearch/display-width': DisplayWidth,
  'omnisearch/duration-rendered': DurationRendered,
  'omnisearch/duration-visible': DurationVisible,
  'omnisearch/email': Email,
  'omnisearch/error-click': ErrorClick,
  'omnisearch/first-input-delay': FirstInputDelay,
  'omnisearch/first-seen': FirstSeen,
  'omnisearch/help': Help,
  'omnisearch/ip': IP,
  'omnisearch/largest-contentful-paint': LargestContentfulPaint,
  'omnisearch/last-seen': LastSeen,
  'omnisearch/mobile-source-file': MobileSourceFile,
  'omnisearch/name': Name,
  'omnisearch/os': OS,
  'omnisearch/page-load': PageLoad,
  'omnisearch/page-refresh': PageRefresh,
  'omnisearch/rage': Rage,
  'omnisearch/referrer': Referrer,
  'omnisearch/scroll-depth': ScrollDepth,
  'omnisearch/session-count': SessionCount,
  'omnisearch/signed-up': SignedUp,
  'omnisearch/state': State,
  'omnisearch/string': String,
  'omnisearch/suspicious-activity': SuspiciousActivity,
  'omnisearch/thrashed-cursor': ThrashedCursor,
  'omnisearch/uncaught-exception': UncaughtException,
  'omnisearch/user-agent': UserAgent,
  'omnisearch/user-id': UserId,
  'omnisearch/visited': Visited,
  'omnisearch/watched-element': WatchedElement,
  'omnisearch/web-source-file': WebSourceFile,
  'omnisearch/pinch-zoom': PinchZoom,
  'omnisearch/text-highlight': Highlight,
  'omnisearch/copy': Copy,
  'omnisearch/paste': Paste,
};
